// extracted by mini-css-extract-plugin
export var banner = "_hw-0";
export var closeButton = "_hw-2";
export var greenCheckmark = "_hw-3";
export var hereLink = "_hw-4";
export var titleIcon = "_hw-1";